export default [
  {
    name: 'CanalSettlementDetail',
    path: '/canal_settlement_detail',
    component: () => import(/* webpackChunkName: "canal" */ './index.vue')
  }
]
